import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/Logo';

export const ForbiddenPage = () => {
  const navigate = useNavigate();
  return (
    <Container maxWidth="sm">
      <Box sx={{ py: 12, textAlign: 'center' }}>
        <Stack spacing={3} alignItems="center">
          <Logo size={56} />
          <Typography variant="h2" color="error" fontWeight={700}>
            403
          </Typography>
          <Typography variant="h5">Nedostatečná oprávnění</Typography>
          <Typography color="text.secondary">
            Tato stránka vyžaduje vyšší roli nebo přihlášení do správné jednotky.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/')}>
            Domů
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};
